import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

export const SkeletonWrapper = styled.div<{ $gap: string }>`
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    gap: ${({ $gap }) => $gap};
`;

export const SkeletonRow = styled.div<{ $gap: string }>`
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: ${({ $gap }) => $gap};
`;

export const SkeletonCol = styled(Skeleton)<{ $flex: number; $height: number }>`
    flex: ${({ $flex }) => $flex} 1 0%;
    height: ${({ $height }) => $height}rem;
`;

export const EmptySkeletonCol = styled.div<{ $flex: number; $height: number }>`
    flex: ${({ $flex }) => $flex} 1 0%;
    height: ${({ $height }) => $height}rem;
`;
